/** Redux scandataUrl may be a JSON string or a plain object depending on the flow. */
export function parseScanData(scanData) {
  if (scanData == null || scanData === "") return null;

  if (typeof scanData === "object") {
    return Object.keys(scanData).length > 0 ? scanData : null;
  }

  if (typeof scanData === "string") {
    try {
      const parsed = JSON.parse(scanData);
      return parsed && typeof parsed === "object" ? parsed : null;
    } catch {
      return null;
    }
  }

  return null;
}
